/**
 * Roles a person can hold as a member of a site — mirrors SITE_MEMBER_ROLES
 * in the BE (services/access/siteRoles.ts), which both the invite and the
 * change-role endpoints validate against. Includes Monitor again (13 Oct
 * 2026); a monitor still reaches a study only through Monitor Assignments.
 */
export const SITE_MEMBER_ROLES = [
  'site_user', 'site_admin', 'principal_investigator', 'sub_investigator', 'coordinator',
  'site_study_designer', 'regulatory_specialist', 'site_pharma', 'finance_billing',
  'monitor', 'auditor', 'clinical_nurse', 'clinical_lab_assistant', 'clinical_qe', 'external_lab',
];

/**
 * External reviewers. Flow (13 Oct 2026): Site Team invites them as
 * Monitor/Auditor (or Change role turns a Site User into one) → Monitor
 * Assignments puts them on a study.
 * That page is the only place a reviewer is added to a study.
 */
export const REVIEWER_SITE_ROLES = ['monitor', 'auditor'];

/** Change role offers the same list as invitations. Mirrors BE SITE_CHANGE_ROLES. */
export const SITE_CHANGE_ROLES = SITE_MEMBER_ROLES;

/** Lowest privilege; the person gets a study role when added to a study. */
export const DEFAULT_SITE_MEMBER_ROLE = 'site_user';

/** A role-picker's starting value: the current role if it can be chosen, else the default. */
export function initialSiteRole(current: string | null | undefined, choices: readonly string[]): string {
  return current && choices.includes(current) ? current : DEFAULT_SITE_MEMBER_ROLE;
}
